/**
 * generateCommerceFlowUrl - Returns a formatted url string used for DTC commerce. The `locale` is
 * only appended to the url if the country is `us` and the `lang` is either `en` or `es`.
 *
 * @param {object} urlsMap - External app-configurations object containing list of `PACKAGE.DEVICE_TYPE` urls
 * @param {array} packages - An array of entitlements (ex: ['ESPN_PLUS', 'ESPN_PLUS_NHL'])
 * @param {string} deviceType - String representing the Databag device type (ex: 'xbox', 'ps4')
 * @param {string} lang - String representing the language; default `en`
 * @param {string} country - String representing the country; default `US`
 *
 * @return {string} - Returns commerce url or an empty string
 */
export default (urlsMap = {}, packages = [], deviceType = '', lang = 'en', country = 'US') => {
    let packageKeys = packages;
    let packagesWithDevice;
    let locale = '';

    if (!urlsMap) {
        console.error('generateCommerceFlowUrl(): urlsMap is undefined, verify config file');
        return '';
    }

    // Priority set here since deviceType is defined
    if (typeof deviceType === 'string' && deviceType.trim() !== '' && packageKeys.length) {
        packagesWithDevice = packageKeys.map(pkg => `${pkg}.${deviceType.toLowerCase()}`);
    }

    if (Array.isArray(packagesWithDevice)) {
        packageKeys = packagesWithDevice;
    }

    const url = urlsMap[packageKeys[0]] || urlsMap.ESPN_PLUS;
    const shouldAppendLocale = (url.indexOf('locale') === -1);
    // Add locale if it doesn't exist; only supporting US (domestic) locale for Spanish (es) and English (en)
    if ((shouldAppendLocale && typeof country === 'string' && country.toLowerCase() === 'us') &&
        (lang === 'en' || lang === 'es')) {
        locale = (url.indexOf('?') !== -1) ? `&locale=${lang}_${country}` : `?locale=${lang}_${country}`;
    }

    return `${url}${locale}`;
};



// WEBPACK FOOTER //
// ./app/webapp/page/Activate/util/generateCommerceFlowUrl.js